import { useContext } from "react";
import {
  Menu,
  ActionIcon,
  Stack,
  Text,
  ThemeIcon,
  Button,
  ScrollArea,
  Indicator,
  Title,
  Divider,
  Group,
  Tooltip,
} from "@mantine/core";
import { IconUpload } from "@tabler/icons-react";
import { useViewportSize } from "@mantine/hooks";
import { UploadContext } from "../contexts/UploadContext";
import ActiveUploadItem from "./ActiveUploadItem";

function UploadsMenu() {
  const {
    uploads: uploading,
    uploadingCount,
    clearAllCompletedUploads,
    cancelAllUploads,
    allCancelling,
  } = useContext(UploadContext);
  const { height: vh, width: vw } = useViewportSize();
  const maxHeight = Math.min(vh - 200, 500);
  const menuWidth = Math.min(600, vw - 10);

  return (
    <Menu shadow="md" width={menuWidth} withArrow>
      <Menu.Target>
        <Indicator
          label={
            <Text size={10} fw={600}>
              {uploadingCount}
            </Text>
          }
          disabled={uploadingCount === 0}
          processing
          position="top-end"
          size={16}
          color="teal"
        >
          <ActionIcon
            variant="subtle"
            color="gray"
            c="var(--mantine-color-text)"
            size="md"
          >
            <IconUpload size={16} />
          </ActionIcon>
        </Indicator>
      </Menu.Target>

      <Menu.Dropdown>
        <Stack gap="xs" p="xs">
          <Group justify="space-between" align="center">
            <Title order={5}>Uploads</Title>
            <Group justify="flex-end" gap="sm" mr="md" mb={2}>
              <Tooltip label="Clear all completed uploads" withArrow>
                <Button
                  variant="subtle"
                  size="xs"
                  onClick={clearAllCompletedUploads}
                >
                  Clear
                </Button>
              </Tooltip>
              <Tooltip label="Cancel all uploading" withArrow>
                <Button
                  variant="subtle"
                  size="xs"
                  onClick={cancelAllUploads}
                  disabled={allCancelling}
                >
                  Cancel
                </Button>
              </Tooltip>
            </Group>
          </Group>
          <Divider />

          <ScrollArea.Autosize mah={maxHeight}>
            {uploading.length === 0 ? (
              <Stack gap={2} align="center" justify="center" w="100%" h={380}>
                <ThemeIcon size={120} radius={80} color="teal" variant="light">
                  <IconUpload size={45} />
                </ThemeIcon>
                <Text size="sm" fw={500} pt="xs">
                  No active uploads
                </Text>
                <Text size="xs" c="dimmed" mb="lg">
                  Click the button above or on the Uploads page to start
                </Text>
              </Stack>
            ) : (
              <Stack gap={8} py={8}>
                {uploading.map((item, i) => (
                  <ActiveUploadItem upload={item} key={`upload-${i}`} />
                ))}
              </Stack>
            )}
          </ScrollArea.Autosize>
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
}

export default UploadsMenu;
